import React from 'react';
const workbenchImage = 'https://cdn.magicpatterns.com/uploads/cXFjkziwpHbLuA9b6eozZC/dal-cartamodello-riferimenti-reali-v2.png';
const steps = [{
  title: 'Scegli il tuo progetto',
  text: 'Trova un motivo che ti piace e comincia da una forma adatta al tuo livello.'
}, {
  title: 'Prepara materiali e cartamodello',
  text: 'Consulta la guida, prepara gli strumenti e stampa il cartamodello nella dimensione adatta al progetto.'
}, {
  title: 'Lavora e modella',
  text: 'Prepara il cordoncino e modellalo seguendo la tecnica spiegata nella guida e il riferimento scelto.'
}, {
  title: 'Rifinisci e personalizza',
  text: 'Cura le estremità e i dettagli, poi scegli come presentare la tua creazione.'
}];
export function HowItWorks() {
  return <section aria-labelledby="how-title" className="on-dark bg-plum text-cream px-5 sm:px-8 py-16 sm:py-24" data-id="element-111" data-mp="grqo646cht38">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 lg:grid-rows-[auto_1fr] gap-x-16 gap-y-10" data-id="element-112" data-mp="14h1h4zhgej6t">
        <div className="lg:col-start-2 lg:row-start-1" data-id="element-113" data-mp="19bp6t1o71jmz">
          <h2 id="how-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold" data-id="element-114" data-mp="2rmpio935qnss">
            Dal cartamodello alla tua creazione, un passo alla volta.
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-cream/85 max-w-lg" data-id="element-115" data-mp="31ciwlgqrvf07">
            Parti da una forma semplice e usa il cartamodello come riferimento mentre impari a lavorare e modellare il cordoncino.
          </p>
        </div>

        <figure className="lg:col-start-1 lg:row-start-1 lg:row-span-2" data-id="element-116" data-mp="3ae09yrcsp2l7">
          <div className="aspect-[4/3] overflow-hidden rounded-[2rem] ring-1 ring-butter/50" data-id="element-117" data-mp="36a0zoqi3z00a">
            <img src={workbenchImage} alt="Tavolo da lavoro con cartamodelli Tricotin con Amore stampati: le lettere A e a, i numeri 1 e 2, un orsetto e due farfalle. Una mano appoggia un cordoncino rosa sul contorno dell’orsetto, accanto a una farfalla in tricotin, gomitoli pastello, un tricotin in legno, filo metallico e pinze" loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-118" data-mp="3k9tky6av8o0v" />
          </div>
          <figcaption className="mt-4 text-center text-xs font-semibold tracking-[0.08em] sm:tracking-[0.18em] text-cream/80" data-id="element-119" data-mp="3l1jx6ptlqzfb">
            SCEGLI · PREPARA · MODELLA · PERSONALIZZA
          </figcaption>
        </figure>

        <ol className="lg:col-start-2 lg:row-start-2 self-start" data-id="element-120" data-mp="2tufus5svjqc">
          {steps.map((step, i) => <li key={step.title} className="relative grid grid-cols-[2.75rem_1fr] gap-x-4 pb-8 last:pb-0" data-id="element-121" data-mp="2rhr9w5jeb4b" data-mpi={i}>
              {i < steps.length - 1 && <span aria-hidden="true" className="absolute left-[1.375rem] top-12 bottom-1 w-px bg-cream/25" data-id="element-122" data-mp="cr8kluid2k2t" />}
              <span className="flex h-11 w-11 items-center justify-center rounded-full border border-cream/35 font-serif text-lg font-semibold text-berry-light" data-id="element-123" data-mp="hjtban5z0h24">
                {i + 1}
              </span>
              <div className="pt-1.5" data-id="element-124" data-mp="qkrfb5gesokp">
                <h3 className="font-serif text-xl font-semibold" data-id="element-125" data-mp="qhls5vrcbwrm">{step.title}</h3>
                <p className="mt-1.5 text-base leading-relaxed text-cream/80" data-id="element-126" data-mp="vit2a1gyh81g">{step.text}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}